<mz-dialog size="xl" #mazarsPreviewModalComponent [uid]="uid" [showFooter]="false" [title]="title">
    <img *ngIf="showFile && !isPdf" class="img-fluid" src="{{ this.previewSrc }}" [alt]="title"/>
    <pdf-viewer *ngIf="showFile && isPdf" [src]="previewSrc" [render-text]="true" [original-size]="false" style="width: 100%; height: 80vh"></pdf-viewer>
</mz-dialog>
